import { icons } from './icons'
import tailwindColors from 'tailwindcss/colors.js'
import type { DefaultColors } from 'tailwindcss/types/generated/colors'

// remove legacy tailwind colors to silence warnings using that
// current colors are properties whereas legacy colors are getters
function removeLegacyColors(colors: DefaultColors) {
  const isCurrentColor = (name: string) =>
    typeof Object.getOwnPropertyDescriptor(colors, name)?.get !== 'function'

  const colorNames = Object.getOwnPropertyNames(colors) as Array<
    keyof DefaultColors
  >

  return Object.fromEntries(
    colorNames.filter(isCurrentColor).map((name) => [name, colors[name]]),
  ) as unknown as DefaultColors
}

const currentTailwindColors = removeLegacyColors(tailwindColors)

const customColors = {
  primary: 'var(--primary)',
  'primary-standard': 'var(--primary)',
  'primary-light': 'var(--primary-light)',
  'primary-900': '#004564',
  'primary-800': '#02608A',
  'primary-700': '#0575A9',
  'primary-600': '#0B8BC4',
  'primary-500': '#1a9dd9',
  'primary-400': '#3AABDE',
  'primary-300': '#5EBAE4',
  'primary-200': '#8CCCEA',
  'primary-100': '#BBE0F2',
  'primary-50': '#ECF9FF',
  secondary: '#56D589',
  'secondary-500': '#56D589',
  'secondary-very-light': '#aaeac4',
  'secondary-light': '#6dda99',
  'secondary-mid-dark': '#32ca6f',
  'secondary-dark': '#3bce76',
  'secondary-very-dark': '#1d7741',
  'clockin-background-gray': '#EEF2F5',
  'clockin-text': '#374151',
  'clockin-text-secondary': '#878D97',
  'clockin-dark': '#2d3644',
  'clockin-early-shift': '#34C759',
  'clockin-late-shift': '#FF9500',
  clockin: '#1a9dd9',
}

const customBorderRadius = {
  'clockin-small': '3px',
  'clockin-medium': '6px',
  'clockin-big': '12px',
}

const customShadows = {
  default: '0px 0px 4px rgba(0, 0, 0, 0.160784)',
  darkerMedium: '0px 0.947675px 10.52905px rgba(0, 0, 0, 0.205392)',
  darkerDefault: '0px 1.89535px 17.0581px rgba(0, 0, 0, 0.25)',
}

const colors = { ...currentTailwindColors, ...customColors }

const primeVuePreset = {
  semantic: {
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '{gray.50}',
          100: '{gray.100}',
          200: '{gray.200}',
          300: '{gray.300}',
          400: '{gray.400}',
          500: '{gray.500}',
          600: '{gray.600}',
          700: '{gray.700}',
          800: '{gray.800}',
          900: '{gray.900}',
          950: '{gray.950}',
        },
        primary: {
          50: 'var(--primary-light)',
          100: 'var(--primary)',
          200: 'var(--primary)',
          300: 'var(--primary)',
          400: 'var(--primary)',
          500: 'var(--primary)',
          600: 'var(--primary)',
          700: 'var(--primary)',
          800: 'var(--primary)',
          900: 'var(--primary)',
          950: 'var(--primary)',
        },
      },
    },
  },
}

export {
  icons,
  colors,
  customColors,
  customBorderRadius,
  customShadows,
  primeVuePreset,
}
